import { Link } from 'react-router';
import { XCircleIcon } from 'lucide-react';

import { useLanguage } from '@/contexts/language-context';
import { Button } from '@/components/ui/button';

// Stripe redirects here when the owner backs out of Checkout.
export function BillingCancel() {
  const { t } = useLanguage();

  return (
    <div className="max-w-md mx-auto flex flex-col items-center gap-4 text-center py-16">
      <XCircleIcon className="w-12 h-12 text-muted-foreground" />
      <h1 className="text-xl font-semibold">{t.billingCancelTitle}</h1>
      <p className="text-sm text-muted-foreground">{t.billingCancelSubtitle}</p>
      <Button asChild>
        <Link to="/billing">{t.billingCancelBackLink}</Link>
      </Button>
    </div>
  );
}
